import React, { Component } from "react";
import SideBar from "../../common/NewSidebar";
import Header from "../../common/Header";
import CookieHandler from "../../common/CookieHandler";
import api from "../../../api/api";
import config from "../../../config/config";
import { Alert } from "@material-ui/lab";
import {
  TextField,
  Snackbar,
  Radio,
  RadioGroup,
  FormControlLabel,
  MenuItem,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import EventIcon from "@material-ui/icons/Event";
import FileUpload from "../../common/FileUpload";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Loader from "../../common/Loader";
const NewRadio = withStyles({
  root: {
    color: "#ccc",
    "&$checked": {
      color: config.themeColor,
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default class CpsContractAdd extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();

    this.state = {
      contract_date: null,
      purchase_contract_id: null,
      purchase_contract_ids: [],
      cps_contract_mappping_data: [
        {
          pc_qualities_id: "0",
          pc_purchase_type_id: "0",
          price_type: "Lumpsum",
          quantity_in_mt: "",
          price_pmt: "",
          total_price: "",
          pc_types_menu: [],
        },
      ],
      purchaseContractList: [],
      purchaseDataForMenu: [],
      vendorDataForMenu: [],
      purchase_qualities: [],
      pc_qualities: [],
      pc_quality_types: [],
      pc_types_menu: [],
      isLoading: true,
      features: [],
      purchase_currency: "",
      payment_terms: "",
      remarks: "",
      currency:
        config.company === "SRPL" ||
        config.company === "AVS" ||
        config.company === "PRPL"
          ? "USD"
          : "IDR",
      vendor_drop_value: { name: "", value: "" },
      currencyData: [],
      files: [
        {
          file_description: "",
          file_name: "",
          file_extension: "",
          file_content: "",
          feature_name: "Cps_contract",
        },
      ],
      contract_type: "Coal Service Fees",
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    }

    const features = this.Cookie.getCookie("features");
    this.setState({ features: features ? features : [] }, () => {
      if (
        !(
          this.state.features.includes("500") ||
          this.state.features.includes("97")
        )
      ) {
        window.location.href = "/dashboard";
      }
    });
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    var status = "";
    // Get purchase contracts API
    await api
      .getPurchaseContracts(loginUserID, status, idToken)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
              if (res.purchase_contract) {
                let purchaseDataforMenu = [];
                const filteredPContracts = res.purchase_contract.filter(
                  (e, indx) => (e, indx) =>
                    e.status !== "Closed" && e.status !== "cancelled"
                );
                filteredPContracts.forEach((item) => {
                  purchaseDataforMenu.push({
                    name: item.contract_no,
                    value: item.id,
                    key: item.id,
                    vendor_name: item.vendor_name,
                  });
                });

                this.setState({
                  purchaseDataForMenu: purchaseDataforMenu,
                  //purchaseContractList: res.purchase_contract,
                  purchaseContractList: filteredPContracts,
                  //isLoading: false
                });
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
    // for get_Currencies
    await api.getCurrencies(loginUserID, idToken).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
          if (res.code === "200") {
            var currencies = [
              <MenuItem value="0" key={-1} disabled>
                Please Select
              </MenuItem>,
            ];
            res.Currency.forEach((item) => {
              currencies.push(
                <MenuItem value={item.currency} key={[item.id]}>
                  {item.currency}
                </MenuItem>
              );
            });
            this.setState({
              currencyData: currencies,
            });
          } else if (res.code === "601") {
            this.setState({
              snackBarErrorOpen: true,
              errorMsg: res.message,
            });
          } else if (res.code === "607") {
            window.location.href = "/logout";
          }
        });
      }
    });

    status = "Active";
    await api.getVendors(loginUserID, idToken, status).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.code === "200") {
            if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
            if (res.vendors) {
              const vendors_menu = [];

              if (res.vendors) {
                res.vendors
                  .filter(
                    (e) =>
                      e.vendor_type === "Coal" || e.vendor_type === "Others"
                  )
                  .forEach((item) => {
                    vendors_menu.push({
                      name: item.vendor_name,
                      value: item.id,
                      key: item.id,
                    });
                  });
                // vendors_menu.push({ name: "Others", value: "Others" });

                this.setState({
                  vendorDataForMenu: vendors_menu,
                  vendors: res.vendors,
                  isLoading: false,
                });
              }
            }
          } else if (res.code === "601") {
            this.setState({
              snackBarErrorOpen: true,
              errorMsg: res.message,
            });
          } else if (res.code === "607") {
            window.location.href = "/logout";
          }
        });
      }
    });
    document.title = config.documentTitle + "New Coal Procurement Contract";
  }

  handlePurchaseContract = (value, idx) => {
    if (value) {
      const loginUserID = this.Cookie.getCookie("loginUserId");
      const idToken = this.Cookie.getIdTokenCookie();
      const status = "";
      const contractNo = value.name;
      var filteredContract = this.state.purchaseContractList.filter(
        (e, index) => e.contract_no === contractNo
      );
      var purchaseContractId =
        filteredContract.length > 0 ? filteredContract[0].pcid : null;

      if (purchaseContractId) {
        api
          .getPurchaseContract(loginUserID, purchaseContractId, idToken, status)
          .then((response) => {
            if (response.status >= 200 && response.status < 300) {
              response.json().then((res) => {
                if (res.code === "200") {
                  if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
                  if (res.purchase_contract) {
                    const pc_qualities = [
                      <MenuItem value="0" key={-1} disabled>
                        {" "}
                        Please Select
                      </MenuItem>,
                    ];
                    if (res.purchase_contract.qualities.length > 0) {
                      for (var i of res.purchase_contract.qualities) {
                        pc_qualities.push(
                          <MenuItem value={i.id} key={i.id}>
                            {i.quality}
                          </MenuItem>
                        );
                      }
                    }
                    this.setState({
                      vendor_drop_value: {
                        name: res.purchase_contract.vendor_name,
                        value: res.purchase_contract.vendor,
                      },
                      vendor_id: res.purchase_contract.vendor,
                      purchase_contract_id: purchaseContractId,
                      vendor_name: res.purchase_contract.vendor_name,
                      purchase_qualities: res.purchase_contract.qualities,
                      purchase_currency: res.purchase_contract.currency,
                      currency: res.purchase_contract.currency,
                      pc_qualities: pc_qualities,
                      pc_qualities_id: "0",
                      purchase_type: null,
                      procurement_quality_standard: null,
                      pc_purchase_type_id: null,
                      isLoading: false,
                    });
                  } else {
                    alert(
                      "Unexpected error occured. Please contact administrator."
                    );
                  }
                } else if (res.code === "607") {
                  window.location.href = "/logout";
                }
              });
            }
          });
      } else {
        alert("Invaild purchase contract");
      }
    }
  };

  removeProcurementRowsHandler = (idx) => () => {
    const rows = this.state.cps_contract_mappping_data;
    rows.splice(idx, 1);
    this.setState({
      cps_contract_mappping_data: rows,
    });
  };

  submitHandler = (e) => {
    this.setState({ submitLoading: true });
    let {
      contract_date,
      contract_type,
      cps_contract_mappping_data,
      payment_terms,
      vendor_id,
      other_vendor_name,
      currency,
      remarks,
      purchase_contract_ids,
    } = this.state;
    // files validation
    let missing_fields = 0;
    let files_missing = 0;
    var files_data = this.state.files;
    for (var obj of files_data) {
      if (obj.file_type !== "" || obj.file_content !== "") {
        if (obj.file_content !== "") {
          if (obj.file_description === "") {
            missing_fields++;
            obj.file_description_error = true;
          } else {
            obj.file_description = obj.file_description.toUpperCase();
          }
        } else if (obj.file_description !== "") {
          if (obj.file_content === "") {
            files_missing++;
          }
        }
      }
    }
    this.setState({
      files: files_data,
    });

    if (missing_fields > 0) {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Please fill mandatory fields.",
        submitLoading: false,
      });
      return;
    }
    if (files_missing > 0) {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Please Select file.",
        submitLoading: false,
      });
      return;
    }
    const content_files = files_data.filter((e) => e.file_content !== "");

    // contract fileds validation
    if (contract_date === null) {
      this.setState({
        contract_date_error: true,
      });
    }

    if (contract_date === null) {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Please fill mandatory files.",
        submitLoading: false,
      });
      return;
    }

    // if (vendor_id === "0" || vendor_id === "Others") {
    //   vendor_id = null;
    // }
    // if (vendor_id === "Others") {
    //   if (other_vendor_name === "") {
    //     this.setState({
    //       vendor_name_error: true,
    //       snackBarErrorOpen: true,
    //       errorMsg: "Please enter vendor name",
    //     });
    //     return;
    //   }
    // }

    // let duplicates_data = cps_contract_mappping_data.filter(
    //   (v, i, a) =>
    //     a.findIndex(
    //       (t) =>
    //         t.pc_qualities_id === v.pc_qualities_id &&
    //         t.pc_purchase_type_id === v.pc_purchase_type_id
    //     ) !== i
    // );
    // if (duplicates_data.length > 0) {
    //   this.setState({
    //     pc_qualitie_error: true,
    //     pc_type_error: true,
    //     snackBarErrorOpen: true,
    //     errorMsg: "No duplicates allowed.",
    //     submitLoading: false,
    //   });
    //   return;
    // }
    let mappping_data = cps_contract_mappping_data;
    for (var i = 0; i < mappping_data.length; i++) {
      if (purchase_contract_ids.length > 1) {
        mappping_data[i].pc_qualities_id = null;
        mappping_data[i].pc_purchase_type_id = null;
      }
      if (mappping_data[i].pc_types_menu) {
        delete mappping_data[i].pc_types_menu;
      }
    }

    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    const contract_kind = "Original";
    const base_contract_id = "";
    const base_contract_no = "";
    api
      .add_cps_contract(
        loginUserID,
        idToken,
        purchase_contract_ids,
        contract_date,
        contract_type,
        vendor_id,
        other_vendor_name,
        currency,
        mappping_data,
        payment_terms,
        remarks,
        contract_kind,
        base_contract_id,
        base_contract_no,
        content_files
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              this.setState(
                {
                  snackBarSuccessOpen: true,
                  successMsg: res.message,
                },
                () => {
                  window.location.href = "/coal-procurement-contracts";
                }
              );
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
                submitLoading: false,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            } else if (res.code === "624") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.columns.toString(),
                submitLoading: false,
              });
            }
          });
        }
      });
  };

  render() {
    return (
      <div id="wraper">
        <SideBar />
        <div className="content">
          <Header />
          <div className="content-header">
            <div className="col-sm text-left pl-0">
              <h4 style={{ padding: "10px 20px", margin: "0px" }}>
                New Coal Procurment Service Contract
              </h4>
            </div>
          </div>
          {this.state.isLoading && <Loader />}
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>
          {!this.state.isLoading && (
            <section className="container p-3">
              <div className="card" style={{ overflowY: "scroll" }}>
                <div className="section_block" style={{ width: "85%" }}>
                  <div className="row mb-3">
                    <div className="col-lg-8 p-0">
                      <label className="form_label mb-0">Contract Type</label>
                      <RadioGroup
                        aria-label="contract_type"
                        name="contract_type"
                        onChange={(e) => {
                          this.setState({
                            contract_type: e.target.value,
                          });
                        }}
                        style={{ flexDirection: "row" }}
                      >
                        <FormControlLabel
                          value="Coal Service Fees"
                          control={
                            <NewRadio
                              checked={
                                this.state.contract_type === "Coal Service Fees"
                              }
                            />
                          }
                          label="Coal Service Fees"
                        />
                        <FormControlLabel
                          value="Procurement Fees"
                          control={
                            <NewRadio
                              checked={
                                this.state.contract_type === "Procurement Fees"
                              }
                            />
                          }
                          label="Procurement Fees"
                        />
                      </RadioGroup>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-4 p-0">
                      <label className="form_label mb-0">
                        Contract Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          autoOk={true}
                          inputVariant="outlined"
                          variant="inline"
                          margin="dense"
                          fullWidth
                          format="dd/MM/yyyy"
                          value={this.state.contract_date}
                          onChange={(date) => {
                            this.setState({
                              contract_date: date,
                              contract_date_error: false,
                            });
                          }}
                          error={this.state.contract_date_error}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <IconButton>
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            className: "pl-0",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className="col-lg-4 pr-0">
                      <label className="form_label mb-0">
                        Purchase Contract
                      </label>
                      <Autocomplete
                        options={this.state.purchaseDataForMenu}
                        getOptionLabel={(option) => option.name}
                        renderOption={(option) => (
                          <React.Fragment>
                            <div className="col-lg p-0 m-0">
                              <label className="form_label mb-0">
                                {option.name}
                              </label>
                              <label
                                className="contract_display_header_value m-0 pl-0"
                                style={{ fontSize: 10, paddingLeft: 5 }}
                              >
                                {option.vendor_name
                                  ? "( " + option.vendor_name + " )"
                                  : null}
                              </label>
                            </div>
                          </React.Fragment>
                        )}
                        onChange={(event, value) => {
                          if (value) {
                            this.setState(
                              {
                                purchase_contract_ids: [value.value],
                              },
                              () => {
                                if (
                                  this.state.purchase_contract_ids.length === 1
                                ) {
                                  this.handlePurchaseContract(value);
                                }
                              }
                            );
                          } else {
                            this.setState({
                              purchase_contract_ids: [],
                              purchase_contract_id: null,
                              purchase_contract_no: "",
                              pc_qualities_id: "0",
                              purchase_type: "",
                              procurement_quality_standard: null,
                              barge_quantity_error_msg: "",
                              barge_planned_quantity_error_msg: "",
                              barge_redfraft_quantity_error_msg: "",
                              total_barge_quantity: "",
                              pc_total_quantity: "",
                              purchaseQualitySelection: null,
                              purchaseTypeSelection: null,
                            });
                          }
                        }}
                        InputProps={{
                          style: {
                            fontFamily: "Poppins",
                            fontSize: "14px",
                          },
                        }}
                        size="small"
                        name="purchaseContract"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Purchase Contract"
                            variant="outlined"
                            fullWidth
                            error={this.state.purchase_contract_error}
                            style={{ top: 8 }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-4 pr-0">
                      <label className="form_label mb-0">
                        Vendor <span style={{ color: "red" }}>*</span>
                      </label>
                      <Autocomplete
                        options={this.state.vendorDataForMenu}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, value) => {
                          if (value) {
                            this.setState({
                              vendor_id: value.value,
                              vendor_name: value.name,
                              vendor_drop_value: {
                                name: value.name,
                                value: value.value,
                              },
                            });
                          } else {
                            this.setState({
                              vendor_id: "",
                              vendor_drop_value: { name: "", value: "" },
                            });
                          }
                        }}
                        InputProps={{
                          style: {
                            fontFamily: "Poppins",
                            fontSize: "14px",
                          },
                        }}
                        size="small"
                        name="purchaseContract"
                        value={this.state.vendor_drop_value}
                        renderOption={(option) => (
                          <React.Fragment>
                            {/* {option.name} ({option.vendor_name}) */}
                            <div className="col-lg-12 p-0 m-0">
                              <label className="form_label mb-0">
                                {option.name}
                              </label>
                              {/* <label className='contract_display_header_value m-0 pl-0' style={{ fontSize: 10, paddingLeft: 5 }}>{option.vendor_name ? "( " + option.vendor_name + " )" : null}</label> */}
                            </div>
                          </React.Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Vendors"
                            variant="outlined"
                            fullWidth
                            // error={this.state.purchase_contract_error}
                            style={{ top: 8 }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-4 p-0">
                      <label className="form_label mb-0">
                        Currency <span style={{ color: "red" }}>*</span>
                      </label>
                      <TextField
                        name="currency"
                        variant="outlined"
                        margin="dense"
                        select
                        value={this.state.currency}
                        onChange={(e) => {
                          this.setState({
                            currency: e.target.value,
                          });
                        }}
                        error={this.state.currencyError}
                        fullWidth
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      >
                        {this.state.currencyData}
                      </TextField>
                    </div>
                    {/* {this.state.vendor_id === "Others" && (
                      <div className="col-lg-4 pr-0">
                        <label className="form_label mb-0">
                          Vendor Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <TextField
                          name="other_vendor_name"
                          variant="outlined"
                          margin="dense"
                          value={this.state.other_vendor_name}
                          fullWidth
                          onChange={(e) => {
                            this.setState({
                              other_vendor_name: e.target.value,
                            });
                          }}
                          inputProps={{ style: { textTransform: "uppercase" } }}
                        />
                      </div>
                    )} */}
                  </div>
                  {this.state.cps_contract_mappping_data.map((e, idx) => (
                    <div className="row mb-3" key={e.purchase_contract_id}>
                      <div className="col-lg-11 p-0">
                        <div className="card-body border_dashed">
                          <div className="row">
                            {this.state.purchase_contract_id &&
                              this.state.purchase_contract_ids.length === 1 && (
                                <div className="col-lg-4 pr-0">
                                  <label className="form_label mb-0">
                                    Purchase Quality{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <TextField
                                    name="pc_quality"
                                    value={e.pc_qualities_id}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    select
                                    error={this.state.pc_qualitie_error}
                                    onChange={(e) => {
                                      let row =
                                        this.state.cps_contract_mappping_data;
                                      row[idx].pc_qualities_id = e.target.value;
                                      let value = "";
                                      value = e.target.value;
                                      const filter_pc_types =
                                        this.state.purchase_qualities.filter(
                                          (e) => e.id === value
                                        );
                                      let pc_quality_types =
                                        filter_pc_types.length > 0
                                          ? filter_pc_types[0].purchase_types
                                          : [];
                                      row[idx].quantity_in_mt =
                                        filter_pc_types.length > 0
                                          ? filter_pc_types[0].quantity_in_mt
                                          : "";
                                      const pc_types_menu = [
                                        <MenuItem value="0" key={-1} disabled>
                                          {" "}
                                          Please Select
                                        </MenuItem>,
                                      ];
                                      for (var i of pc_quality_types) {
                                        pc_types_menu.push(
                                          <MenuItem value={i.id} key={i.id}>
                                            {i.purchase_type}
                                          </MenuItem>
                                        );
                                      }
                                      row[idx].pc_types_menu = pc_types_menu;
                                      this.setState({
                                        cps_contract_mappping_data: row,
                                        pc_quality_types: pc_quality_types,
                                        pc_types_menu: pc_types_menu,
                                        pc_qualitie_error: false,
                                      });
                                    }}
                                  >
                                    {this.state.pc_qualities}
                                  </TextField>
                                </div>
                              )}
                            {e.pc_qualities_id !== "0" &&
                              this.state.purchase_contract_ids.length === 1 && (
                                <div className="col-lg-4 pr-0">
                                  <label className="form_label mb-0">
                                    Purchase Type{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <TextField
                                    name="pc_type"
                                    value={e.pc_purchase_type_id}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    select
                                    error={this.state.pc_type_error}
                                    onChange={(e) => {
                                      let row =
                                        this.state.cps_contract_mappping_data;
                                      row[idx].pc_purchase_type_id =
                                        e.target.value;
                                      // let value = ''
                                      // console.log(e.target.value);
                                      // value = e.target.value;
                                      //const filter_pc_type = this.state.pc_quality_types.filter(e => e.id === value);
                                      //let purchase_price = filter_pc_type.length > 0 ? filter_pc_type[0].price_pmt : '';

                                      //row[idx].price_pmt = purchase_price;
                                      //row[idx].total_price = Number(row[idx].quantity_in_mt) * Number(row[idx].price_pmt)
                                      this.setState({
                                        cps_contract_mappping_data: row,
                                        pc_type_error: false,
                                      });
                                    }}
                                  >
                                    {e.pc_types_menu}
                                  </TextField>
                                </div>
                              )}
                            <div className="col-lg-4 pr-0">
                              <label className="form_label mb-0">
                                Price Type
                              </label>
                              <RadioGroup
                                aria-label="price_type"
                                name="price_type"
                                onChange={(e) => {
                                  let row =
                                    this.state.cps_contract_mappping_data;
                                  row[idx].price_type = e.target.value;
                                  this.setState({
                                    cps_contract_mappping_data: row,
                                  });
                                }}
                                style={{ flexDirection: "row" }}
                              >
                                <FormControlLabel
                                  value="Lumpsum"
                                  control={
                                    <NewRadio
                                      checked={e.price_type === "Lumpsum"}
                                    />
                                  }
                                  label="Lumpsum"
                                />
                                <FormControlLabel
                                  value="Per MT"
                                  control={
                                    <NewRadio
                                      checked={e.price_type === "Per MT"}
                                    />
                                  }
                                  label="Per MT"
                                />
                              </RadioGroup>
                            </div>
                            <div className="col-lg-4 pr-0">
                              <label className="form_label mb-0">
                                Quantity <span style={{ color: "red" }}>*</span>
                              </label>
                              <TextField
                                name="quantity_in_mt"
                                value={e.quantity_in_mt}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                type="number"
                                placeholder="Enter Value"
                                onChange={(e) => {
                                  let row =
                                    this.state.cps_contract_mappping_data;
                                  row[idx].quantity_in_mt = e.target.value;
                                  row[idx].total_price =
                                    Number(
                                      row[idx].quantity_in_mt
                                        ? row[idx].quantity_in_mt
                                        : 0
                                    ) *
                                    Number(
                                      row[idx].price_pmt
                                        ? row[idx].price_pmt
                                        : 0
                                    );

                                  this.setState({
                                    cps_contract_mappping_data: row,
                                  });
                                }}
                              ></TextField>
                            </div>
                            {e.price_type === "Per MT" && (
                              <div className="col-lg-4 pr-0">
                                <label className="form_label mb-0">
                                  Price PMT{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <TextField
                                  name="price_pmt"
                                  value={e.price_pmt}
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  type="number"
                                  placeholder="Enter Value"
                                  onChange={(e) => {
                                    let row =
                                      this.state.cps_contract_mappping_data;
                                    row[idx].price_pmt = e.target.value;
                                    row[idx].total_price =
                                      Number(
                                        row[idx].quantity_in_mt
                                          ? row[idx].quantity_in_mt
                                          : 0
                                      ) *
                                      Number(
                                        row[idx].price_pmt
                                          ? row[idx].price_pmt
                                          : 0
                                      );

                                    this.setState({
                                      cps_contract_mappping_data: row,
                                    });
                                  }}
                                  disabled={e.price_type === "Lumpsum"}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        className="adornment_background"
                                      >
                                        {this.state.currency !== "0"
                                          ? this.state.currency
                                          : null}
                                      </InputAdornment>
                                    ),
                                    style: {
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                      padding: 0,
                                    },
                                  }}
                                ></TextField>
                              </div>
                            )}
                            {e.price_type === "Per MT" ? (
                              <div className="col-lg-4">
                                <label className="form_label mb-3">
                                  Total Price
                                </label>
                                <div className="contract_display_header_value">
                                  {e.total_price}
                                </div>
                              </div>
                            ) : (
                              <div className="col-lg-4">
                                <label className="form_label mb-0">
                                  Total Price
                                </label>
                                <TextField
                                  name="total_price"
                                  value={e.total_price}
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  type="number"
                                  placeholder="Enter Value"
                                  onChange={(e) => {
                                    let row =
                                      this.state.cps_contract_mappping_data;
                                    row[idx].total_price = e.target.value;
                                    this.setState({
                                      cps_contract_mappping_data: row,
                                    });
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        className="adornment_background"
                                      >
                                        {this.state.currency !== "0"
                                          ? this.state.currency
                                          : null}
                                      </InputAdornment>
                                    ),
                                    style: {
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                      padding: 0,
                                    },
                                  }}
                                ></TextField>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {this.state.cps_contract_mappping_data.length > 1 && (
                        <div className="col-lg-1 d-flex justify-content-center m-auto">
                          <div className="icon_hover text-align-center">
                            <i
                              className="fa fa-trash-o m-auto"
                              onClick={this.removeProcurementRowsHandler(idx)}
                              style={{
                                fontSize: 24,
                                color: config.themeColor,
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                  <div className="row mt-2 mb-2">
                    <button
                      type="button"
                      onClick={() => {
                        const item = {
                          purchase_contract_id: "",
                          pc_qualities_id: "0",
                          pc_purchase_type_id: "0",
                          price_type: "Lumpsum",
                          quantity_in_mt: "",
                          price_pmt: "",
                          total_price: "",
                          pc_types_menu: [],
                        };

                        this.setState({
                          cps_contract_mappping_data: [
                            ...this.state.cps_contract_mappping_data,
                            item,
                          ],
                        });
                      }}
                      className="header_button header_button_text addrow_button_adjustment"
                      style={{ color: config.themeColor }}
                    >
                      Add More
                    </button>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-12 p-0">
                      <label className="form_label mb-0">Remarks</label>
                      <TextField
                        name="remarks"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows={4}
                        placeholder="Remarks"
                        value={this.state.remarks}
                        onChange={(e) => {
                          this.setState({
                            remarks: e.target.value,
                          });
                        }}
                        fullWidth
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-12 p-0">
                      <label className="form_label mb-0">Payment Terms </label>
                      <TextField
                        name="payment_terms"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows={4}
                        placeholder="Payment Terms"
                        value={this.state.payment_terms}
                        onChange={(e) => {
                          this.setState({
                            payment_terms: e.target.value,
                          });
                        }}
                        fullWidth
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </div>
                  </div>
                  {(this.state.features.includes("505") ||
                    this.state.features.includes("97")) && (
                    <FileUpload
                      files={this.state.files}
                      feature_name="Cps_contract"
                      callbackFn={(data) => this.setState({ files: data })}
                    />
                  )}
                </div>
              </div>
              <footer className="row bottom_buttons_section">
                <button
                  type="button"
                  className="btn previous_button"
                  name="submit"
                  onClick={() =>
                    (window.location.href = "/coal-procurement-contracts")
                  }
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className="btn next_button"
                  name="Back"
                  onClick={this.submitHandler}
                  disabled={this.state.submitLoading}
                >
                  <span
                    className={
                      this.state.submitLoading
                        ? "spinner-grow spinner-grow-sm mr-2"
                        : ""
                    }
                  ></span>
                  SUBMIT
                </button>
              </footer>
            </section>
          )}
        </div>
      </div>
    );
  }
}
